import { BTIconHighlightOutlined } from "commonComponents/btWrappers/BTIcon";
import { BTMenu } from "commonComponents/btWrappers/BTMenu/BTMenu";

interface IMenuItemDrawProps {
    fileId: number;
    onClick: () => Promise<void>;
}

const MenuItemDraw = ({ fileId, onClick, ...antProps }: IMenuItemDrawProps) => {
    return (
        <BTMenu.Item
            {...antProps}
            key={`draw-menuitem-${fileId}`}
            testid={`draw-menuitem-${fileId}`}
            onClick={onClick}
        >
            <BTIconHighlightOutlined /> Draw
        </BTMenu.Item>
    );
};

export default MenuItemDraw;
